import ReactDOM from 'react-dom';
import React from 'react';
import App from '../src/App';

const rootEl = document.getElementById('react-element');

rootEl && ReactDOM.render(<App />, rootEl);
